export const calculateActivityScores = (activities, scoring) => {
  const activityIds = ['AIRATTEND', 'AIRTRAIN'];
  const hoursSums = activityIds.reduce((acc, activityId) => {
    acc[activityId] = 0;
    return acc;
  }, {});

  activities.forEach(activity => {
    if (activityIds.includes(activity.activityId)) {
      hoursSums[activity.activityId] += parseFloat(activity.hours);
    }
  });

  let summary = activityIds.reduce((acc, activityId) => {
    const score = (hoursSums[activityId] % 10) * scoring.find(stage => stage.id === activityId).score;
    acc[activityId] = score;
    return acc;
  }, {});

  return summary;
};
